import { FormProvider, useForm } from "react-hook-form";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { defaultFormTheme } from "../../../../atoms/defaultFormTheme";
import { ClientFormData, FormData } from "../type";
import Fields from "./fields";
import { useMyCalenderContext } from "../../../../pages/my-calendar/context";
import { useEffect, useRef } from "react";
import { useMyCalenderFilterContext } from "../filterContext";
import { labelValueStringType, labelValueType } from "../../../client/all-clients/types";
import { removeWhiteSpacesFromForm } from "../../../../utils/utils";

export type ClientProps = {
    clientValues: labelValueType[];
    fk_client?: labelValueStringType[];
    client_type?: labelValueStringType[];
}

const ClientFormFilter = ({ clientValues, fk_client, client_type }: ClientProps) => {
    const { setExpanded, clearFilter } = useMyCalenderFilterContext();
    const { setFilters } = useMyCalenderContext();
    const defaultValues: ClientFormData = {
        client_contacts: clientValues,
        fk_client: fk_client,
        client_type: client_type
    }

    const onSubmit = (formData: ClientFormData) => {
        const newFormData = removeWhiteSpacesFromForm(formData, [])
        let fk_client = "";
        let client_type = "";
        if (newFormData?.fk_client?.length) {
            fk_client = newFormData?.fk_client?.map((g) => g.value).join(",");
        }
        if (newFormData?.client_type) {
            client_type = newFormData?.client_type?.map((g) => g.value).join(",");
        }
        const client_contacts = newFormData.client_contacts.map((g) => g.value).join(",");
        setExpanded((prev) => ({ ...prev, client: !prev.client }))
        setFilters((prev) => {
            const newFilters = {
                ...prev,
                isFilterChange: true,
                isFilterApplied: true,
                sidebarFilters: {
                    ...prev.sidebarFilters,
                    client_contacts,
                    fk_client,
                    client_type,
                }
            }
            return newFilters;
        })
    };

    const methods = useForm({
        defaultValues
    });

    function handleReset() {
        clearFilterReset();
        setFilters((prev) => ({
            ...prev,
            isFilterChange: true,
            isFilterApplied: true,
            sidebarFilters: {
                ...prev.sidebarFilters,
                client_contacts: null,
                fk_client: null,
                client_type: null,
            }
        }))
    }

    function clearFilterReset() {
        methods.reset({
            client_contacts: [],
            fk_client: [],
            client_type: [],
        });
        setExpanded((prev) => ({ ...prev, client: false }))
    }

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (clearFilter.current > 0) {
            clearFilterReset()
        }
    }, [clearFilter.current])

    const defaultTheme = createTheme(defaultFormTheme);

    return (
        <FormProvider {...methods}>
            <ThemeProvider theme={defaultTheme}>
                <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
                    <Fields handleReset={handleReset} />
                </form>
            </ThemeProvider>
        </FormProvider>
    );
};

export default ClientFormFilter;
